import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, startTrackEvent, stopTrackEvent } from '../services/appInsights';

export function usePageTracking(): void {
  const location = useLocation();
  const previousPathRef = useRef<string>('');

  useEffect(() => {
    const currentPath = location.pathname + location.search;

    if (previousPathRef.current !== currentPath) {
      if (previousPathRef.current) {
        stopTrackEvent(`PageView:${previousPathRef.current}`);
      }

      trackPageView(location.pathname, window.location.href, {
        referrer: document.referrer,
        search: location.search,
        hash: location.hash
      });

      startTrackEvent(`PageView:${currentPath}`);
      previousPathRef.current = currentPath;
    }

    return () => {
      stopTrackEvent(`PageView:${currentPath}`);
    };
  }, [location]);
}

export function useTrackPageTime(pageName: string): void {
  const startTimeRef = useRef<number>(Date.now());

  useEffect(() => {
    startTimeRef.current = Date.now();

    return () => {
      const duration = Date.now() - startTimeRef.current;
      stopTrackEvent(
        `TimeOnPage:${pageName}`,
        {
          pageName,
          url: window.location.href
        },
        {
          durationMs: duration
        }
      );
    };
  }, [pageName]);
}
